import type {ConnectElementConfig} from '../ConnectElementList';

export const NetworkCostPassthroughReportConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "network-cost-passthrough-report" */ '../../../components/NetworkCostPassthroughReport/NetworkCostPassthroughReport'
    ),
  enabledKey: 'network_cost_passthrough_report',
  sentryTeam: 'platform_billing_and_monetization',
  releaseState: 'internal',
  teamOwner: 'platform-billing-and-monetization',
  description:
    'Network cost passthrough reporting for connected accounts - plan-level and transaction-level views.',
  friendlyName: 'Network Cost Passthrough Report',
};
